<template lang="pug">
header.web-page-header
  .web-page-header__text
    h1.web-page-header__title {{ title }}
    p.web-page-header__subtitle(v-if="subtitle") {{ subtitle }}
  .web-page-header__actions(v-if="$slots.actions")
    slot(name="actions")
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// Page header for every page in the web app side menu (see .claude/design-profile.md).
// Detail pages use a compact bar with a back arrow instead.
export default defineComponent({
  name: 'WebPageHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
  },
});
</script>

<style lang="scss" scoped>
.web-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 32px 24px 24px;
  border-bottom: 1px solid #e5e7eb;

  @media (min-width: 768px) {
    padding: 48px 40px 40px;
  }

  @media (min-width: 1024px) {
    padding: 56px 64px 48px;
  }
}

.web-page-header__text {
  min-width: 0;
}

.web-page-header__title {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.2;
  color: #1a1a1a;

  @media (min-width: 768px) {
    font-size: 32px;
  }
}

.web-page-header__subtitle {
  margin: 8px 0 0;
  font-size: 15px;
  line-height: 1.5;
  color: #6b7280;

  @media (min-width: 768px) {
    font-size: 16px;
  }
}

.web-page-header__actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}
</style>
